var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{class:{ 'switch-invisible': _vm.markedForDeletion },staticStyle:{"margin-top":"0","padding-top":"0"},attrs:{"input-value":_vm.value,"aria-label":_vm.switchAriaLabel,"disabled":_vm.switchDisabled,"dense":"","hide-details":"","inset":_vm.inset,"flat":_vm.flat},on:{"change":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }